import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { merchantStatusStyles } from '../styles';

type JustifiStatusTextProps = {
  label: string;
  trackingId: string;
  isStatusActive?: boolean;
  value?: string;
};
export const JustifiStatusText = ({ label, trackingId, isStatusActive, value }: JustifiStatusTextProps) => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  return (
    <div css={merchantStatusStyles.accountInfo}>
      <Text color='light' size='medium'>
        {label}
      </Text>
      {isStatusActive !== undefined && (
        <Text
          css={{
            color: isStatusActive ? theme.colors.success50 : theme.colors.warning40,
          }}
          weight='bold'
          data-trackingid={`pay-portal-settings-label-${trackingId}`}
        >
          {isStatusActive ? t('Active') : t('Pending Approval')}
        </Text>
      )}
      {value && (
        <Text weight='bold' data-trackingid={`pay-portal-settings-label-${trackingId}`}>
          {value}
        </Text>
      )}
    </div>
  );
};
